// extracted by mini-css-extract-plugin
export default {"container":"OneyeuuC7_XH69UVWsOb","info-container":"IqPBCJJua_Z8o2gEwU83","type-container":"Wv4cLBLQRakLIuP2CEU2","date":"EkoO2ZE53lsP_pmt2hmA","message":"rUB1psn4fYmKe6ixlWgU"};